import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { Alert } from 'src/app/classes/alert';
import { BaseClass } from 'src/app/classes/base_class';
import { RealCompetition, RealCompetitionResponse } from 'src/app/classes/real_competition';
import { User, UserResponse } from 'src/app/classes/user';
import { AbstractService } from 'src/app/services/abstract.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { RealSeasonService } from 'src/app/services/real-season.service';
import { RealSeason } from 'src/app/classes/real_season';
import { RealCompetitionService } from 'src/app/services/real-competition.service';

@Component({
  selector: 'app-single-competition',
  templateUrl: './single-competition.component.html',
  styleUrls: ['./single-competition.component.scss']
})
export class SingleCompetitionComponent implements OnInit {
  busy: Subscription;
  faPlus = faSave;
  rels: Array<any>;
  singleResponse: UserResponse | RealCompetitionResponse ;
  cols: any;
  isChecked = [];
  @Input() id: number;
  @Input() single: User | RealCompetition ;
  @Input() componentService: AbstractService;
  @Input() routePart: string;
  @Input() routeSingleDescription: string;
  @Output() pathListEvent = new EventEmitter<any[]>();
  @ViewChild('alertbox1', { static: false }) alertbox1: AlertboxComponent;
  new_id: number;
  seasons: RealSeason
  selected_seasons: String = ""
  constructor(private router: Router, public realseasonService: RealSeasonService, public realCompetitionService: RealCompetitionService) { }

  ngOnInit(): void {
    this.getSingle(this.id);
    this.getSeason()
    this.getChecks()
  }

  getControlType(control_name: string): string {
    if (control_name in this.single.controls) {
      return this.single.controls[control_name];
    }
    return '';
  }

  getSingle(id: number) {
    const isNew = id == 0 ? true : false;
    if (id == 0) id = 1;
    this.busy = this.componentService.get(id).subscribe(
      (data: UserResponse | RealCompetitionResponse ) => {
        if (!isNew) {
          for (const key in data.payload) {
            if (Object.prototype.hasOwnProperty.call(this.single, key)) {
              this.single[key] = data.payload[key];
            }
          }
        }

        // this.cols = data.admin_info.cols.filter((c) => c.indexOf('.') == -1); // rimuovo i campi fk
        this.cols = [
          "id",
          "description",
          // "active",
          // "data_inizio",
          // "data_fine",
          "currentSeason_startDate",
          "currentSeason_endDate",
        ];
        let path_part_1 = '';
        if (Object.prototype.hasOwnProperty.call(this.single, 'calciatore')) {
          path_part_1 = this.single['calciatore'];
        } else if (Object.prototype.hasOwnProperty.call(this.single, 'indirizzo_email')) {
          path_part_1 = this.single['indirizzo_email'];
        } else if (Object.prototype.hasOwnProperty.call(this.single, 'description')) {
          path_part_1 = this.single['description'];
        } else {
          path_part_1 = this.single['id'].toString();
        }
        this.pathListEvent.emit([path_part_1.toString(), `${this.routePart}/${this.single.id}`]);
        // for (const iterator of data.admin_info.rels) {
        //   this.getRels(iterator);
        // }
      },
      (err) => {
        // console.error(err);
        console.log('ERRORE: ' + JSON.stringify(err.error.description));
      }
    );
  }

  saveItem() {
    const payload = BaseClass.cleanup(this.single);

    if (this.single.id == 0) {
      this.busy = this.realCompetitionService.save(payload).subscribe({
        next: (response) => {
          const provaAlert: Alert = new Alert();
          provaAlert.msg = "salvataggio riuscito";
          provaAlert.timeout = 5000;
          provaAlert.type = 'normal';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
          this.router.navigate([`/${this.routePart}/list`]);
          console.log(response.payload.id)
          this.new_id = response.payload.id
        },
        error: (err: HttpErrorResponse) => {
          let msg = '';
          if ('errors' in err.error) {
            msg = JSON.stringify(err.error.errors)
          } else {
            msg = err.error.status + ' - ' + err.error.payload;
          }
          const provaAlert: Alert = new Alert();
          provaAlert.msg = msg;
          provaAlert.timeout = 5000;
          provaAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
        },
      });
    } else {
      this.busy = this.componentService.update(this.single.id, payload).subscribe({
        next: () => {
          const provaAlert: Alert = new Alert();
          provaAlert.msg = "Salvataggio riuscito";
          provaAlert.timeout = 5000;
          provaAlert.type = 'primary';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert);
          // this.router.navigate([`/${this.routePart}/${this.single.id}`]);
        },
        error: (err: HttpErrorResponse) => {
          let msg = '';
          if ('errors' in err.error) {
            msg = JSON.stringify(err.error.errors)
          } else {
            msg = err.error.status + ' - ' + err.error.payload;
          }
          const provaAlert: Alert = new Alert();
          provaAlert.msg = msg;
          provaAlert.timeout = 5000;
          provaAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
        },
      });
      if(this.id != 0){
        this.new_id = this.id
      }
      this.busy = this.realseasonService.saveSeasonrealcompetitions(this.new_id, this.isChecked).subscribe({
        next: () => {
            console.log("CREATO")
        },
        error: (err) => {
          console.log(err)
        }
      })
      //salvataggio season-competition
      // let season_competition_to_add = []
      // season_competition_to_add = this.selected_seasons.split(",")
      // season_competition_to_add.forEach((seasonId) => {
      //   let cleanSeasonId = seasonId.trim();
      //   cleanSeasonId = parseInt(cleanSeasonId)


    }
  }

  getSeason(){
    this.busy = this.realseasonService.list2().subscribe({
      next: (data) => {
        this.seasons = data.payload
      },
      error: (err) => {console.log(err)}
  })}


  onSelectTab(value) {
    console.log("Tab selected", value)
  }

  onSelectResult(season) {
    // console.log(season)
    console.log("Stagione iniziale: ", this.isChecked)
    // let seasons = this.selected_seasons
    // for (const [index, value] of this.isChecked.entries()) {
    //   console.log("index: ", index, "\nvalue: ", value)
    //   if(value != undefined){
    //     if(value && value != null || value == true) seasons += season + ',';
    //     break;
        
    //   }
    // }
    // console.log("aggiunta stagione: ", seasons)
    // this.selected_seasons = seasons
  }
  onCheckboxChanged(evt) {
    console.log("onCheckboxChanged", this.isChecked);

    evt.stopPropagation();
  }

  getChecks(){
    this.busy = this.realseasonService.getSeasonRealcompetitions(this.id).subscribe({
      next: (data) => {
        this.isChecked = data.payload
      },
      error: (err) => {console.log(err)}
  })}
  }


